"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGDPRCountry = isGDPRCountry;

var _countries = require("./constants/countries");

/**
 * Checks if country is regulated by GDPR
 * @param {String} ISOTwoLetterCountryCode
 * @return {Boolean}
 */
function isGDPRCountry(ISOTwoLetterCountryCode) {
  if (!ISOTwoLetterCountryCode) return false;
  var countryCodeUpperCase = ISOTwoLetterCountryCode.toUpperCase();
  return isEuropeanUnionCountry(countryCodeUpperCase) || _countries.ADDITIONAL_GDPR_COUNTRIES.includes(countryCodeUpperCase);
}
/**
 * Checks if a country code is in the European Union
 * @param  {String}  ISOTwoLetterCountryCode
 * @return {Boolean}
 */


function isEuropeanUnionCountry(ISOTwoLetterCountryCode) {
  return _countries.EU_COUNTRY_CODES.includes(ISOTwoLetterCountryCode.toUpperCase());
}